import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap'

export default class extends Controller {
  static targets = ["form", "confirmModal", "userEmailDisplay"]

  connect() {
    // Try to find form within the controller element
    this.form = this.element.querySelector('form')
    
    // If not found, try to find form in the entire document that's within this controller's scope
    if (!this.form) {
      const forms = document.querySelectorAll('form')
      for (let form of forms) {
        if (this.element.contains(form)) {
          this.form = form
          break
        }
      }
    }
    
    // If still not found, try to find form by looking for the closest form ancestor
    if (!this.form) {
      this.form = this.element.closest('form')
    }
    
    this.confirmationModal = null
  }

  showConfirmation(event) {
    event.preventDefault()
    
    // Get user email from the span element
    const userEmailElement = document.querySelector('.user-email')
    const userEmail = userEmailElement ? userEmailElement.textContent : 'Unknown User'
    this.userEmailDisplayTarget.textContent = userEmail
    
    this.confirmationModal = new bootstrap.Modal(this.confirmModalTarget)
    this.confirmationModal.show()
  }

  confirmUpdate(event) {
    event.preventDefault()
    
    // Hide confirmation modal
    if (this.confirmationModal) {
      this.confirmationModal.hide()
    }

    // Check if TOTP verification is needed
    const currentAdminHasTotp = this.element.dataset.currentAdminTotpEnabled === 'true'
    
    if (currentAdminHasTotp) {
      this.showTotpModal()
    } else {
      this.submitFormDirectly()
    }
  }

  submitForm(event) {
    event.preventDefault()
    
    // Check if TOTP verification is needed
    const currentAdminHasTotp = this.element.dataset.currentAdminTotpEnabled === 'true'
    
    if (currentAdminHasTotp) {
      this.showTotpModal()
    } else {
      this.submitFormDirectly()
    }
  }

  showTotpModal() {
    const formData = this.getFormData()
    
    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: this.getActionUrl(),
        actionMethod: this.getActionMethod(),
        formData: formData
      }
    })
    document.dispatchEvent(event)
  }

  submitFormDirectly() {
    if (this.form) {
      this.form.submit()
    } else {
      console.error('Form element not found')
      // Fallback: submit the form using the element
      this.element.submit()
    }
  }

  getFormData() {
    if (!this.form) {
      console.error('Form element not found')
      return {}
    }
    
    const formData = new FormData(this.form)
    const data = {}
    
    for (let [key, value] of formData.entries()) {
      if (key.includes('[') && key.includes(']')) {
        // Handle nested parameters like admin[role_ids][]
        const matches = key.match(/^(\w+)\[(\w+)\](\[\])?$/)
        if (matches) {
          const parent = matches[1]
          const child = matches[2]
          const isArray = matches[3] === '[]'
          
          if (!data[parent]) data[parent] = {}
          if (isArray) {
            if (!data[parent][child]) data[parent][child] = []
            data[parent][child].push(value)
          } else {
            data[parent][child] = value
          }
        }
      } else {
        data[key] = value
      }
    }
    
    return data
  }

  getActionUrl() {
    if (!this.form) {
      console.error('Form element not found')
      return ''
    }
    // Remove /edit from the URL if it exists
    let actionUrl = this.form.action
    if (actionUrl.endsWith('/edit')) {
      actionUrl = actionUrl.replace('/edit', '')
    }
    return actionUrl
  }

  getActionMethod() {
    if (!this.form) {
      console.error('Form element not found')
      return 'PATCH'
    }
    // For Rails forms, we need to check the _method field or use PATCH for updates
    const methodField = this.form.querySelector('input[name="_method"]')
    if (methodField) {
      return methodField.value.toUpperCase()
    }
    if (this.form.method) {
      return this.form.method.toUpperCase()
    }
    return 'PATCH'
  }
} 